export default () => ({
  entities: 'statistics',
  statistics: [],
  scheduled: 0,
  attended: 0,
  canceled: 0,
  total: 0
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/agendas-statistics/resources/data.js